export { SearchOnPage } from './SearchOnPage';
export type { SearchOnPageProps } from './SearchOnPage';
